<script setup lang="ts">
import { computed } from 'vue'
import BuyRechargeButton from '@/landing/components/buttons/BuyRechargeButton.vue'
import SendRechargeButton from '@/landing/components/buttons/SendRechargeButton.vue'
import PaidInvoicesButton from '@/landing/components/buttons/PaidInvoicesButton.vue'
import SlimFoundationButton from '@/landing/components/buttons/SlimFoundationButton.vue'
import Maintenance from '@/components/common/Maintenance.vue'
import { useMaintenanceStore } from '@/stores/maintenance'
import { EMaintenanceSize, EMaintenanceType } from '@/shared/enum/maintenance.enum'

const maintenanceStore = useMaintenanceStore()

const isActivePartialMaintenance = computed(
  () =>
    maintenanceStore.maintenance.MaintenanceModeOn &&
    maintenanceStore.maintenance.Type === EMaintenanceType.PARTIAL
)

const isActiveTotalMaintenance = computed(
  () =>
    maintenanceStore.maintenance.MaintenanceModeOn &&
    maintenanceStore.maintenance.Type === EMaintenanceType.TOTAL
)

const isMaintenanceMPC = computed(
  () => maintenanceStore.maintenanceMPC.MaintenanceModeOn && !isActiveTotalMaintenance.value
)

const blurAndDisableButtonGral = computed(
  () =>
    maintenanceStore.maintenance.MaintenanceModeOn &&
    maintenanceStore.maintenance.Type !== EMaintenanceType.BITCOIN
)

const blurAndDisableButtonInvoice = computed(
  () => maintenanceStore.maintenanceMPC.MaintenanceModeOn || isActiveTotalMaintenance.value
)
</script>

<template>
  <section class="relative flex flex-col w-full gap-3 mt-4">
    <Maintenance
      v-if="isActiveTotalMaintenance"
      :type="maintenanceStore.maintenance.Type"
      :endDate="maintenanceStore.maintenance.EndDate"
    />
    <div class="relative flex flex-col">
      <BuyRechargeButton
        :class="{ 'blur-sm pointer-events-none cursor-none': blurAndDisableButtonGral }"
        :disabled="blurAndDisableButtonGral"
      />
      <Maintenance
        v-if="isActivePartialMaintenance"
        :type="maintenanceStore.maintenance.Type"
        :endDate="maintenanceStore.maintenance.EndDate"
        :size="EMaintenanceSize.BIG"
      />
    </div>
    <div class="relative flex flex-row gap-3 h-36">
      <div class="flex w-1/2">
        <SendRechargeButton
          class="w-full"
          :class="{ 'blur-sm pointer-events-none cursor-none': blurAndDisableButtonGral }"
          :disabled="blurAndDisableButtonGral"
        />
        <Maintenance
          v-if="isActivePartialMaintenance"
          :type="maintenanceStore.maintenance.Type"
          :endDate="maintenanceStore.maintenance.EndDate"
          :size="EMaintenanceSize.SMALL"
        />
      </div>
      <div class="flex w-1/2">
        <PaidInvoicesButton
          class="w-full"
          :class="{ 'blur-sm pointer-events-none cursor-none': blurAndDisableButtonInvoice }"
        />
        <Maintenance
          v-if="isMaintenanceMPC"
          :type="EMaintenanceType.PARTIAL"
          :size="EMaintenanceSize.SMALL"
          :endDate="maintenanceStore.maintenanceMPC.EndDate"
        />
      </div>
    </div>
    <SlimFoundationButton />
  </section>
</template>

<style scoped>
.landing__button {
  @apply active:scale-95 ease-in-out duration-300;
}
</style>
